import * as React from 'react';

/* eslint-disable react/prop-types */
import { withHomePageSection } from 'components/withHomePageSection';
import { colorsV2 } from 'style/colors-v2';
import {
  useCoursesWithTeacher,
  groupCoursesForDisplay
} from 'shared/CourseIeltsDetail/dataMapper';
import { useCoursesGroupDataV3 } from 'shared/CourseLanding/data/useCoursesGroupDataV3';
import styled from 'styled-components';
import { Typography } from 'components/DesignSystemV2/Typography';
import { CourseTeacherCard } from './CourseTeacherCard';
import { useKeenSlider } from 'keen-slider/react';
import { fromScreen } from 'utils/media-query/responsive.util';

const Main = styled.div`
  display: grid;
  gap: 48px;
`;

const MainContent = styled.div`
  display: none;
  gap: 24px;
  &.template-column-3 {
    grid-template-columns: repeat(3, 1fr);
  }
  &.template-column-4 {
    grid-template-columns: repeat(4, 1fr);
  }
  ${fromScreen(1144)} {
    display: grid;
  }
`;

const MainContentMobile = styled.div`
  display: flex;
  ${fromScreen(1144)} {
    display: none;
  }
`;

const routeLink = item => {
  if (item.classGroup.includes('TOEIC')) {
    return '/toeic';
  }
  if (item.classGroup.includes('SAT')) {
    return '/sat';
  }
  if (item.classGroup.includes('GMAT/GRE')) {
    return '/gmat-gre';
  }
  if (item.classGroup.includes('Tiếng Anh')) {
    return '/tieng-anh-giao-tiep';
  }
  return item.linkLevel;
};

const getColumnTemplate = length => {
  switch (true) {
    case length === 6:
    case length === 3:
      return 3;
    case length >= 4:
      return 4;

    default:
      return 3;
  }
};
const CoursesBase = ({ data, headerTitle }) => {
  const templateColumn = getColumnTemplate(data?.length);
  const [sliderRef] = useKeenSlider({
    slides: {
      perView: 1.5,
      spacing: 24
    },
    breakpoints: {
      '(min-width: 776px)': {
        slides: {
          perView: 2.5,
          spacing: 24
        }
      }
    },
    duration: 500,
    mode: 'free-snap'
  });
  return (
    <Main>
      <Typography
        variant="bold/24-32"
        tabletVariant="bold/32-40"
        desktopVariant="bold/40-48"
        color={colorsV2.black100}
        v3
      >
        {headerTitle}
      </Typography>
      <MainContent className={`template-column-${templateColumn}`}>
        {data?.map((eachItem, idx) => {
          const { name, description, teacher, updatedAt } = eachItem || {};
          const { listingImageHandler, displayName } = teacher || {};
          return (
            <CourseTeacherCard
              key={idx}
              listingImageHandler={listingImageHandler}
              description={description}
              displayName={displayName}
              name={name}
              updatedAt={updatedAt}
              linkLevel={routeLink(eachItem)}
            />
          );
        })}
      </MainContent>
      <MainContentMobile ref={sliderRef} className="keen-slider">
        {data?.map((eachItem, idx) => {
          const { name, description, teacher, updatedAt } = eachItem || {};
          const { listingImageHandler, displayName } = teacher || {};
          return (
            <CourseTeacherCard
              key={idx}
              listingImageHandler={listingImageHandler}
              description={description}
              displayName={displayName}
              name={name}
              updatedAt={updatedAt}
              linkLevel={routeLink(eachItem)}
            />
          );
        })}
      </MainContentMobile>
    </Main>
  );
};

export const Courses = withHomePageSection(
  ({ level, headerTitle }) => {
    const { courseWithTeachers } = useCoursesWithTeacher();
    const { desktopGroupCourses } = useCoursesGroupDataV3();
    const sortedCourses = groupCoursesForDisplay(
      courseWithTeachers,
      desktopGroupCourses
    );
    return (
      <CoursesBase data={sortedCourses?.[level]} headerTitle={headerTitle} />
    );
  },
  {
    style: {
      backgroundColor: colorsV2.white100
    }
  },
  {
    className: 'section-courses'
  }
);
